// extracted by mini-css-extract-plugin
module.exports = {"iconNotification":"iconNotification__OyB67","active":"active__36BDT"};